<template>
    <div class="about-initiative-form10">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="De que maneira as potências podem acessar as oportunidades de apoio oferecidas pela sua iniciativa? (marque todas que se aplicam)"
                label-for="ways"
                class="required"
            >
                <b-form-checkbox-group
                    id="ways"
                    name="ways"
                    v-model="$v.form.ways.selected.$model"
                    :options="form.ways.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('ways')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['maneira_acessar_oportunidade'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform &&
                            getAuthorizationData &&
                            !getAuthorizationData['maneira_acessar_oportunidade'].value
                    "
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.waysOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.ways.selected.includes(5)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('ways')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Qual é a faixa de aporte financeiro que sua iniciativa fornece às potências periféricas? (para cada uma por ano)"
                label-for="financialContributionRange"
                class="required"
            >
                <b-form-checkbox-group
                    id="financialContributionRange"
                    name="financialContributionRange"
                    v-model="form.financialContributionRange.selected"
                    :options="form.financialContributionRange.options"
                    value-field="item"
                    text-field="text"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['faixa_aporte_financeiro'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['faixa_aporte_financeiro'].value"
                />

                <b-form-invalid-feedback :state="validateState('financialContributionRange')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Quais tipos de iniciativas sociais você apoia? (marque todas que se aplicam)"
                label-for="socialInitiativeTypes"
                class="required"
            >
                <b-form-checkbox-group
                    id="socialInitiativeTypes"
                    name="socialInitiativeTypes"
                    v-model="$v.form.socialInitiativeTypes.selected.$model"
                    :options="form.socialInitiativeTypes.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('socialInitiativeTypes')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['tipos_iniciativas_sociais'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform && getAuthorizationData && !getAuthorizationData['tipos_iniciativas_sociais'].value
                    "
                />

                <b-form-invalid-feedback :state="validateState('socialInitiativeTypes')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <b-form-input
                    name="others"
                    style="float: right;"
                    class="col-md-6"
                    v-model="form.socialInitiativeTypesOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.socialInitiativeTypes.selected.includes(16)"
                ></b-form-input>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm9' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm9')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('AboutInitiativeForm11')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            initiative: null,
            progress: 49.86,
            message: null,
            authorizationData: null,
            isUpdate: false,
            form: {
                ways: {
                    selected: [],
                    options: [
                        { text: 'Por edital', item: 1, value: 1 },
                        { text: 'Via leis de incentivo', item: 2, value: 2 },
                        { text: 'Por e-mail', item: 3, value: 3 },
                        { text: 'Por recomendação', item: 4, value: 4 },
                        { text: 'Outros (especifique)', item: 5, value: 5 }
                    ]
                },
                waysOthers: null,
                financialContributionRange: {
                    selected: [],
                    options: [
                        { text: 'Até 10 mil reais', item: 1, value: 1 },
                        { text: 'Entre 10 e 20 mil reais', item: 2, value: 2 },
                        { text: 'Entre 20 e 50 mil reais', item: 3, value: 3 },
                        { text: 'Entre 50 e 100 mil reais', item: 4, value: 4 },
                        { text: 'Entre 100 e 500 mil reais', item: 5, value: 5 },
                        { text: 'Mais de 500 mil reais', item: 6, value: 6 }
                    ]
                },
                socialInitiativeTypes: {
                    selected: [],
                    options: [
                        { text: 'Coletivo (sem CNPJ)', item: 1, value: 1 },
                        { text: 'Liderança comunitária (Pessoa Física)', item: 2, value: 2 },
                        { text: 'Empreendedor (MEI)', item: 3, value: 3 },
                        { text: 'Movimento', item: 4, value: 4 },
                        { text: 'Empresa', item: 5, value: 5 },
                        { text: 'Negócio Social / Impacto', item: 6, value: 6 },
                        { text: 'Escola (pública ou particular)', item: 7, value: 7 },
                        { text: 'OSCs / ONGs / Entidades (com CNPJ)', item: 8, value: 8 },
                        { text: 'Hospitais / Centro Clínico ou Terapêutico', item: 9, value: 9 },
                        { text: 'Partido Político', item: 10, value: 10 },
                        { text: 'Instituição do Sistema “S” (Senai, Senac, Sesi, Sebrae, Sesc)', item: 11, value: 11 },
                        { text: 'Rede', item: 12, value: 12 },
                        { text: 'Instituição Religiosa', item: 13, value: 13 },
                        { text: 'Universidade ou Autarquia', item: 14, value: 14 },
                        { text: 'Sindicato', item: 15, value: 15 },
                        { text: 'Outros (especifique)', item: 16, value: 16 }
                    ]
                },
                socialInitiativeTypesOthers: null
            }
        }
    },
    validations: {
        form: {
            ways: {
                selected: { required }
            },
            financialContributionRange: {
                selected: { required }
            },
            socialInitiativeTypes: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.financialContributionRange.selected = data.faixa_aporte_financeiro || []

            this.form.ways.selected =
                data.maneira_acessar_oportunidade === null
                    ? []
                    : data.maneira_acessar_oportunidade.filter(item => typeof item === 'number')

            this.form.waysOthers =
                data.maneira_acessar_oportunidade === null
                    ? null
                    : data.maneira_acessar_oportunidade.filter(item => typeof item !== 'number')[0].waysOthers

            this.form.socialInitiativeTypes.selected =
                data.tipos_iniciativas_sociais === null
                    ? []
                    : data.tipos_iniciativas_sociais.filter(item => typeof item === 'number')

            this.form.socialInitiativeTypesOthers =
                data.tipos_iniciativas_sociais === null
                    ? null
                    : data.tipos_iniciativas_sociais.filter(item => typeof item !== 'number')[0]
                          .socialInitiativeTypesOthers

            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data
                        this.form.financialContributionRange.selected = data.faixa_aporte_financeiro || []

                        this.form.ways.selected =
                            data.maneira_acessar_oportunidade === null
                                ? []
                                : data.maneira_acessar_oportunidade.filter(item => typeof item === 'number')

                        this.form.waysOthers =
                            data.maneira_acessar_oportunidade === null
                                ? null
                                : data.maneira_acessar_oportunidade.filter(item => typeof item !== 'number')[0]
                                      .waysOthers

                        this.form.socialInitiativeTypes.selected =
                            data.tipos_iniciativas_sociais === null
                                ? []
                                : data.tipos_iniciativas_sociais.filter(item => typeof item === 'number')

                        this.form.socialInitiativeTypesOthers =
                            data.tipos_iniciativas_sociais === null
                                ? null
                                : data.tipos_iniciativas_sociais.filter(item => typeof item !== 'number')[0]
                                      .socialInitiativeTypesOthers
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                maneira_acessar_oportunidade: this.form.ways.selected,
                faixa_aporte_financeiro: this.form.financialContributionRange.selected,
                tipos_iniciativas_sociais: this.form.socialInitiativeTypes.selected,
                percentual: currentProgress
            }

            data.maneira_acessar_oportunidade = [
                ...data.maneira_acessar_oportunidade,
                { waysOthers: this.form.waysOthers }
            ]

            data.tipos_iniciativas_sociais = [
                ...data.tipos_iniciativas_sociais,
                { socialInitiativeTypesOthers: this.form.socialInitiativeTypesOthers }
            ]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'AboutInitiativeForm11' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.ways.options = this.form.ways.options.filter(x => this.form.ways.selected.includes(x.value))

                this.form.financialContributionRange.options = this.form.financialContributionRange.options.filter(x =>
                    this.form.financialContributionRange.selected.includes(x.value)
                )

                this.form.socialInitiativeTypes.options = this.form.socialInitiativeTypes.options.filter(x =>
                    this.form.socialInitiativeTypes.selected.includes(x.value)
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm10-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm10.vue